window.openReportTable = (evt, Name, Header) => {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" selectedReport", " unselectedReport");
    }
    document.getElementById(Name).style.display = "block";
    evt.currentTarget.classList.remove("unselectedReport")
    evt.currentTarget.classList.add("selectedReport");
    localStorage.setItem("selectedReport", [Name]);
}
